// @mui
import React from 'react';
import { GlobalStyles as MUIGlobalStyles } from '@mui/material';

// ----------------------------------------------------------------------

const GlobalStyles = () => {
  const inputGlobalStyles = (
    <MUIGlobalStyles
      styles={{
        '*': {
          boxSizing: 'border-box',
        },
        html: {
          margin: 0,
          padding: 0,
          width: '100%',
          height: '100%',
          WebkitOverflowScrolling: 'touch',
        },
        body: {
          margin: 0,
          padding: 0,
          width: '100%',
          height: '100%',
        },
        '#root': {
          width: '100%',
          height: '100%',
        },
        input: {
          '&[type=number]': {
            MozAppearance: 'textfield',
            '&::-webkit-outer-spin-button': {
              margin: 0,
              WebkitAppearance: 'none',
            },
            '&::-webkit-inner-spin-button': {
              margin: 0,
              WebkitAppearance: 'none',
            },
          },
        },
        img: {
          display: 'block',
          maxWidth: '100%',
        },
        ul: {
          margin: 0,
          padding: 0,
        },
        '.rsm-svg': {
          transition: 'all 0.6s cubic-bezier(0.4, 0, 0.2, 1)',
        },
        '.rsm-geography': {
          transition:
            'fill 0.3s ease, stroke 0.3s ease, stroke-width 0.3s ease, opacity 0.3s ease',
        },
        '.rsm-marker': {
          transition: 'transform 0.3s ease, opacity 0.3s ease',
          transformOrigin: 'center center',
        },
      }}
    />
  );

  return inputGlobalStyles;
};

export default GlobalStyles;
